import http from "../../utils/http"

/**
 * 獲取訂單初始化數據
 * @param {object} params
 */
export function payment(params) {
    // 獲取訂單初始化數據(批發)
    if(params.type&&params.type == 'wholesale'){
        return http({
            url: "/wholesale/api/ordercreate/payment",
            data: params,
            forceLogin: true
        })
    }else if(params.type&&params.type == 'bargaining'){
        return http({
            url: "/bargain/api/ordercreate/payment",
            data: params,
            forceLogin: true
        })
    }else if(params.type&&params.type == 'virtual'){
        return http({
            url: "/onlinebooking/api/ordercreate/payment",
            data: params,
            forceLogin: true
        })
    }else{
        return http({
            url: "/api/ordercreate/payment",
            data: params,
            forceLogin: true
        })
    }
}
/**
 * 獲取訂單初始化數據
 * @param {object} params
 */
export function calculate(params) {
    //獲取訂單初始化數據(批發)
    if(params.type&&params.type == 'wholesale'){
        return http({
            url: "/wholesale/api/ordercreate/calculate",
            data: params,
            forceLogin: true
        })
    }else if(params.type&&params.type == 'bargaining'){
        return http({
            url: "/bargain/api/ordercreate/calculate",
            data: params,
            forceLogin: true
        })
    }else if(params.type&&params.type == 'virtual'){
        delete params.type
        return http({
            url: "/onlinebooking/api/ordercreate/calculate",
            data: params,
            forceLogin: true
        })
    }else{
        return http({
            url: "/api/ordercreate/calculate",
            data: params,
            forceLogin: true
        })
    }
}

/**
 * 訂單創建
 * @param {object} params
 */
export function orderCreate(params) {
    if(params.type&&params.type == 'wholesale'){
        return http({
            url: "/wholesale/api/ordercreate/create",
            data: params,
            forceLogin: true
        })
    }else if(params.type&&params.type == 'bargaining'){
        return http({
            url: "/bargain/api/ordercreate/create",
            data: params,
            forceLogin: true
        })
    }else if(params.type&&params.type == 'virtual'){
        delete params.type
        return http({
            url: "/onlinebooking/api/ordercreate/create",
            data: params,
            forceLogin: true
        })
    } else{
        return http({
            url: "/api/ordercreate/create",
            data: params,
            forceLogin: true
        })
    }
    
}

/**
 * 驗證支付密碼
 * @param {object} params
 */
export function checkpaypassword(params) {
    return http({
        url: "/api/member/checkpaypassword",
        data: params,
        forceLogin: true
    })
}

/**
 * 根據店鋪ID獲取加價購列表
 * @param {object} params
 */
 export function increasepricePage(params) {
    return http({
        url: "/increaseprice/api/increaseprice/page",
        data: params,
        forceLogin: true
    })
}

/**
 * 根據id獲取收營員列表
 * @param {object} params
 */
 export function getArtificerBySkuId(params) {
    return http({
        url: "/onlinebooking/api/goods/getArtificerBySkuId",
        data: params,
        forceLogin: true
    })
}
/**
 * 獲取收營員時間
 * @param {object} params
 */
 export function getOrderTime(params) {
    return http({
        url: "/onlinebooking/api/ordercreate/getOrderTime",
        data: params,
        forceLogin: true
    })
}





